import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { sprintf } from 'sprintf-js';

import { environment } from '../../environments/environment';
import { BaseService } from './base.service';

@Injectable()
export class EmailTemplateAlignmentService extends BaseService {
  private alignmentUrl = `${environment.apiBaseUrl}/companies/%(company_id)s/email_templates/%(email_template_id)s/alignment`;

  constructor(
    protected http: HttpClient,
  ) {
    super(http, '');
  }

  getAlignment(urlParams: any): Observable<any> {
    const url = sprintf(this.alignmentUrl, urlParams);
    return this.http.get<any>(url);
  }

  saveAlignment(urlParams: any, payload: any): Observable<any> {
    const url = sprintf(this.alignmentUrl, urlParams);
    return this.http.put<any>(url, payload);
  }
}
